<template>
    <div id="searchTemplate">
         <div class="p-tit-c">
                <div class="businessList-filter">
                           <div class="businessList-filter-list flex align-cen">
            <div class="fl-le flex align-cen">
          <div class="label">{{active == 'first' ? '登录账号': '操作账号'}}：</div>
          <div class="el-select1">
            <el-input :placeholder="active == 'first' ? '请输入登录账号' : '请输入操作账号'" v-model="search" clearable> </el-input>
          </div>
         </div>
      </div>
                 <div class="businessList-filter-list flex align-cen" v-if="active == 'first'">
            <div class="fl-le flex align-cen">
          <div class="label">所属企业：</div>
          <div class="el-select1">
            <el-input placeholder="请输入所属企业" v-model="search1" clearable> </el-input>
          </div>
         </div>
      </div>
         <div class="businessList-filter-list flex align-cen">
        <div class="fl-le flex align-cen">
          <div class="label">{{active == 'first' ? '登录应用': '操作应用'}}：</div>
          <el-select
            v-model="value"
            clearable
            placeholder="请选择"
             @change="classSelect"
          >
            <el-option
              v-for="item in list"
              :key="item.id"
              :label="item.appName"
              :value="item.appName"
            >
            </el-option>
          </el-select>
        </div>
                </div>
                  <div class="businessList-filter-list flex align-cen">
        <div class="label">{{active == 'first' ? '登录时间': '操作时间'}}：</div>
        <el-date-picker
          v-model="value2"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions2"
          @change="classSelect"
        >
        </el-date-picker>
      </div>
        <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="classSelect">
          搜索
        </div>
        <div class="public-btn-small-text" @click="reset1">
          重置筛选条件
        </div>
      </div>
             </div>
             </div>
    </div>
</template>
<script>
import {getApplicationList} from "@/api/index/index" //应用列表
export default {
    name:'searchTemplate',
     props: {
    active: [String, Number],
    },
    data(){
        return {
         pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        list:[],
        search:'',
        search1:'',
        value:'',
        value2:'',
        start_time:'',
        end_time:'',
        }
    },
    created(){
        this.gethisInfo()
    },
    methods: {
             // 筛选
        classSelect(){
          this.$emit('sendStatus', this.value,this.value2,this.search,this.search1)
        },
    //  搜索
    searchList(){

    },
      reset(){
     this.value = ""
     this.value2 = ""
     this.search = ""
     this.search1 = ""
    },
    reset1(){
     this.value = ""
     this.value2 = ""
     this.search = ""
      this.search1 = ""
     this.$emit('sendStatus', this.value,this.value2,this.search,this.search1)
    },
    // 时间筛选
    dataSuccess(){

    },
             // 获取列表
        gethisInfo(){
            let params = {
                current: 1,
                size:1000,
            }
            getApplicationList(params)
            .then(res => {
              this.list = res.data.records
            })
            .catch(err => {
            })
        },
    }
}
</script>
<style lang="scss" scoped>
#searchTemplate{
      .businessList-filter {
    padding-top: 10px;
    .businessList-filter-list {
      margin-top: 20px;
      .fl-rt {
        padding-left: 30px;
      }
    }
    .businessList-filter-list:first-child {
      margin-top: 0;
    }
  }
}
</style>